import * as _LocaleTypes from './LocaleTypes';
import * as _PageTypes from './PageTypes';
import * as _PageNames from './PageNames';
import * as _SystemTypes from './SystemTypes';
import * as _ModuleTypes from './ModuleTypes';
import * as _LocationTypes from './LocationTypes';
import * as _DefaultDateTypes from './DefaultDateTypes';
import * as _DeferredTypes from './DeferredTypes';

export const LocaleTypes = Object.freeze(_LocaleTypes);
export const PageTypes = Object.freeze(_PageTypes);
export const PageNames = Object.freeze(_PageNames);
export const SystemTypes = Object.freeze(_SystemTypes);
export const ModuleTypes = Object.freeze(_ModuleTypes);
export const LocationTypes = Object.freeze(_LocationTypes);
export const DefaultDateTypes = Object.freeze(_DefaultDateTypes);
export const DeferredTypes = Object.freeze(_DeferredTypes);